<template>
    <common-layout-component2 show-back="false" show-user="false" show-admin="false" show-logout="false" :show-notice="false">

        <template v-slot:nav-message>
            <p>お探しのページが見つかりませんでした</p>
        </template>
        <template v-slot:body>
            <div class="container">
                <div class="columns is-multiline cat-wrapper">
                    <div class="column cat-item top">
                        <a href="javascript:void(0)" @click="navTo('/admin/menu', 1)">
                            <h3 style="text-align:center;">トップページへ戻る</h3>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </common-layout-component2>
</template>
<script>
    import CommonLayoutComponent2 from './CommonLayoutComponent2.vue';
    export default {
        computed: {
            currentGrant: function() {

                //console.log("grant", this.$store.state.userInfo);
                return this.$store.state.userInfo.grant;
            }
        },

        methods: {
            navTo: function(path, grant) {
                if(grant > this.currentGrant) {
                    return;
                }

                this.$router.push({'path':path});
            }
        },

        components: {
            CommonLayoutComponent2,
        },
    }
</script>
<style scoped>
    .menu-item-disabled {
        /*border-radius:1em;*/
        background-color:gray;
        color: #dedede;
        cursor:default;

        /*padding-top:0.3em;
        padding-bottom:0.3em;*/

    }

    .cat-item a {
        text-decoration: none;
    }

    .menu-item-disabled:hover {
        background-color:white !important;
        color: #dedede !important;
        text-decoration: none;
        cursor:default;

        /*border-radius: 20px;
        box-shadow: 2px 2px 8px #ccc;
        min-height: 120px;
        padding: 15px;*/

        border-radius: 20px !important;
        box-shadow: 2px 2px 8px #ccc !important;
        /*min-height: 120px !important;*/
        padding: 15px !important;
    }
</style>
